import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import { createSearchParams } from 'react-router-dom';
import {
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
  TableBody,
  //Icon,
  Table,
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import WithRouter from './WithRouter';

class RenderProjectTree extends Component {
  constructor(props) {
    super(props);
    //this.chart = null;
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
  }

  navigateWithUrl(e, target, obj) {
    const { navigate, state } = this.props;
    const projectId = obj.project;
    const project_version_id = obj.project_version;
    const uploadedFileIds = obj.file_id;

    state.pages.setUpdateValueFromTree(true);

    if (target === 'project') {
      navigate({
        pathname: '/results/overview',
        search: createSearchParams({
          project: projectId,
        }).toString()
      });
    } else if (target === 'project_version') {
      navigate({
        pathname: '/results/overview',
        search: createSearchParams({
          project: projectId,
          project_version: project_version_id,
        }).toString()
      });
    } else {
      navigate({
        pathname: '/results/overview',
        search: createSearchParams({
          uploaded_file_id: uploadedFileIds,
        }).toString()
      });
    }
  }

  renderProjectTree(obj) {
    let totalCount = 0;
    const projectName = obj.project_name;
    const projectVersionList = obj.project_version_list;
    const projectId = obj.project_id;

    for (let i = 0; i < projectVersionList.length; i++) {
      const fileList = projectVersionList[i].uploaded_file_list;
      for (let j = 0; j < fileList.length; j++) {
        totalCount++;
      }
    }

    return Object.assign(obj.project_version_list).map(
      (versionList, k) => {
        return Object.assign(versionList.uploaded_file_list).map(
          (fileList, l) => {
            return (
              <TableRow key={uuidv4()}>
                {
                  k === 0 && l === 0 ? (
                    <TableCell
                      rowSpan={totalCount}
                      title={[projectName].join('')}
                      verticalAlign="middle"
                    >
                      <span
                        className="link"
                        onClick={(e) => { return this.navigateWithUrl(e, 'project', { project: projectId, project_version: '', file_id: [] }); }}
                        onKeyUp={(e) => { return this.navigateWithUrl(e, 'project', { project: projectId, project_version: '', file_id: [] }); }}
                      >
                        {projectName}
                      </span>
                    </TableCell>
                  ) : null
                }
                {
                  l === 0 ? (
                    <TableCell
                      rowSpan={Object.assign(versionList.uploaded_file_list).length}
                      verticalAlign="middle"
                    >
                      <span
                        className="link"
                        onClick={(e) => { return this.navigateWithUrl(e, 'project_version', { project: projectId, project_version: versionList.project_version_id, file_id: [] }); }}
                        onKeyUp={(e) => { return this.navigateWithUrl(e, 'project_version', { project: projectId, project_version: versionList.project_version_id, file_id: [] }); }}
                      >
                        {versionList.project_version_name}
                      </span>
                    </TableCell>
                  ) : null
                }
                <TableCell
                  title={[fileList.uploaded_file_name].join('')}
                >
                  <span
                    className="link"
                    onClick={(e) => { return this.navigateWithUrl(e, 'uploaded_file_id', { project: projectId, project_version: versionList.project_version_id, file_id: fileList.uploaded_file_ids }); }}
                    onKeyUp={(e) => { return this.navigateWithUrl(e, 'uploaded_file_id', { project: projectId, project_version: versionList.project_version_id, file_id: fileList.uploaded_file_ids }); }}
                  >
                    {fileList.uploaded_file_name}
                  </span>
                </TableCell>
              </TableRow>
            );
          }
        );
      }
    );
  }

  render() {
    const { treeData, translate, tableType } = this.props;

    if (!treeData) {
      return;
    }
    return (
      <Table
        className="tree_view_table"
        celled
        structured
        compact={tableType}
      >
        <TableHeader
          className="tree_view_header"
        >
          <TableRow>
            <TableHeaderCell>
              {translate('list.title.project')}
              (
              {treeData.project_count}
              )
            </TableHeaderCell>
            <TableHeaderCell>
              {translate('list.title.project_version')}
              (
              {treeData.project_version_count}
              )
            </TableHeaderCell>
            <TableHeaderCell>
              {translate('list.title.uploaded_files')}
              (
              {treeData.uploaded_file_count}
              )
            </TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {(treeData.project_list && treeData.project_list.length !== 0) ? (
            treeData.project_list.map((item) => {
              return this.renderProjectTree(item);
            })
          ) : null}
        </TableBody>
      </Table>
    );
  }
}

export default WithRouter(RenderProjectTree);
